import { useTranslations } from '~/src/hooks/useTranslations'
import { FormikProps } from 'formik'
import FormikTextField from '~/src/components/mui-wrappers/fields/FormikTextField'
import PhoneInput from '~/src/components/mui-wrappers/styled/phone-input'
import { Box } from '@mui/material'
import { CustomerProfileFormInterface } from '~/src/types/forms/CustomerProfileFormInterface'
import { useEoValue } from '~/src/hooks/useEoState'
import AUTHENTICATION_FLOW_STATE, {
  AuthenticationFlowCustomer,
  AuthenticationFlowState
} from '~/src/stores/authentication-flow'
import { useRef } from 'react'
import useCustomerProfilePasswordFieldState
  from '~/src/hooks/forms/customer-profile-form/useCustomerProfilePasswordFieldState'

interface Props {
  form: FormikProps<CustomerProfileFormInterface>,
  fieldsColor: 'container' | 'content',
  disabledFields: Record<keyof CustomerProfileFormInterface, boolean>,
}

const ExtraInfoCustomerFields = ({ form, fieldsColor = 'content', disabledFields }: Props) => {
  const { t } = useTranslations()
  const authenticationFlowState = useEoValue<AuthenticationFlowState>(AUTHENTICATION_FLOW_STATE)
  const { isShown: isPasswordShown } = useCustomerProfilePasswordFieldState()
  const presettedValues = useRef<Pick<AuthenticationFlowCustomer, 'email' | 'phone' | 'password'>>({
    email: authenticationFlowState.customer?.email,
    phone: authenticationFlowState.customer?.phone,
    password: authenticationFlowState.customer?.password
  })

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 2
    }}>
      <FormikTextField
        TextFieldProps={{
          form,
          disabled: !!presettedValues.current.email || disabledFields.email,
          autoComplete: 'missing-email',
          fullWidth: true,
          color: fieldsColor,
          name: 'email',
          type: 'email',
          inputMode: 'email',
          variant: 'outlined',
          required: true,
          label: t('form.email')
        }}
      />

      { isPasswordShown && !presettedValues.current.password && (
        <FormikTextField
          TextFieldProps={{
            form,
            disabled: !!presettedValues.current.password || disabledFields.password,
            autoComplete: 'missing-password',
            fullWidth: true,
            color: fieldsColor,
            name: 'password',
            type: 'password',
            inputMode: 'text',
            variant: 'outlined',
            required: true,
            label: t('auth.password')
          }}
        />
      )}

      <FormikTextField
        TextFieldProps={{
          form,
          fullWidth: true,
          color: fieldsColor,
          name: 'firstName',
          label: t('form.firstname'),
          required: true,
          variant:'outlined',
          disabled: disabledFields.firstName
        }}
      />

      <FormikTextField
        TextFieldProps={{
          form,
          fullWidth: true,
          color: fieldsColor,
          name: 'lastName',
          label: t('form.lastname'),
          required: true,
          variant:'outlined',
          disabled: disabledFields.lastName
        }}
      />

      <PhoneInput
        PhoneInputProps={{
          form,
          disabled: !!presettedValues.current.phone || disabledFields.phone,
          fullWidth: true,
          color: fieldsColor,
          name: 'phone',
          label: t('form.phone'),
          required: true,
          variant: 'outlined'
        }}
      />
    </Box>
  )
}

export default ExtraInfoCustomerFields
